import React from 'react';
import {useIntl, message} from '@sail/intl';

const errorTitle = message({
  id: 'mkt-ssr.app_error.title',
  defaultMessage: 'Unexpected error',
  description: 'Error boundary title shown when an error occurs',
});

const errorDescription = message({
  id: 'mkt-ssr.app_error.description',
  defaultMessage:
    "Sorry, we're experiencing an issue on this page. Please try refreshing the page.",
  description: 'Error boundary description message',
});

const errorActions = message<{
  DashboardLink: React.ReactNode;
  ApiLink: React.ReactNode;
  ContactLink: React.ReactNode;
}>({
  id: 'mkt-ssr.app_error.actions',
  defaultMessage:
    "<DashboardLink>View your Dashboard</DashboardLink>, check the <ApiLink>Stripe API status</ApiLink>, or <ContactLink>get in touch</ContactLink> if you can't find what you're looking for.",
  description: 'Error boundary message that shows a list of actions to take',
});

interface AppErrorViewProps {
  error: Error;
}

export function AppErrorView({error: _error}: AppErrorViewProps) {
  const intl = useIntl();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        maxWidth: '850px',
        margin: '0 auto',
      }}
    >
      <h1 style={{fontSize: '24px', marginBottom: '16px'}}>
        {intl.formatMessage(errorTitle)}
      </h1>
      <p style={{fontSize: '16px', marginBottom: '24px', color: '#666'}}>
        {intl.formatMessage(errorDescription)}
      </p>
      <p style={{fontSize: '12px', marginBottom: '24px', color: '#666'}}>
        {intl.formatMessage(errorActions, {
          DashboardLink: ((chunks: React.ReactNode) => (
            <a href="https://dashboard.stripe.com">{chunks}</a>
          )) as unknown as React.ReactNode,
          ApiLink: ((chunks: React.ReactNode) => (
            <a href="https://status.stripe.com">{chunks}</a>
          )) as unknown as React.ReactNode,
          ContactLink: ((chunks: React.ReactNode) => (
            <a href="https://support.stripe.com/email">{chunks}</a>
          )) as unknown as React.ReactNode,
        })}
      </p>
    </div>
  );
}
